import styled from 'styled-components'
import { Surface } from '../../components/DashboardPrimitives'
import { WINDOW_SIZE } from '../../util/Constants'
import { focusRing } from './MoneyStyles'

// One currency, one page: identity and balance up top, then cards for
// holdings, rails, and activity. Same 8px rhythm as the Money home.

export const CurrencyLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 4px auto 40px;
  max-width: 720px;
  min-width: 0;
  width: 100%;
`

export const BackLink = styled.button`
  align-items: center;
  align-self: flex-start;
  background: none;
  border: 0;
  border-radius: 8px;
  color: var(--text-muted, #6b7280);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  gap: 6px;
  padding: 6px 4px;
  transition: color 0.16s ease;

  &:hover {
    color: var(--ink, #20242d);
  }

  ${focusRing}
`

export const CurrencyHero = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 4px 8px;
`

export const CurrencyIdentity = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`

export const CurrencyName = styled.span`
  color: var(--text-soft, #7d8492);
  font-size: 13px;
  line-height: 1.3;
`

export const CurrencyActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const CurrencyCard = styled(Surface)`
  gap: 6px;
  padding: 16px 18px;
`

export const CurrencyCardLabel = styled.span`
  color: var(--text-muted, #6f7888);
  font-size: 11.5px;
  font-weight: 500;
  letter-spacing: 0.05em;
  line-height: 1.25;
  padding-bottom: 4px;
  text-transform: uppercase;
`

export const HoldingRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 36px;
  padding: 4px 0;

  & + & {
    border-top: 1px solid #eef1f7;
  }

  @media (max-width: ${WINDOW_SIZE.MOBILE_LARGE}) {
    gap: 12px;
  }
`
